/* ══════════════════════════════════════════════════════════════════════════
   HŐTÉRKÉP: csempeszínek (Terminál-javítások 1. kör, A.6)
   ─────────────────────────────────────────────────────────────────────────
   A háttérszínek NEM változnak (a 18.3 lecke ábrája ezekre épül), csak ide
   kerültek a HeatmapTab.js-ből. A felirat színe sávonként úgy van választva,
   hogy a kontraszt normál szövegnél legalább 4,5:1, félkövérnél (szimbólum)
   legalább 3:1 legyen; mérés: node scripts/hoterkep-kontraszt.mjs.
   A legvilágosabb zöldön (+1…+3%) sötét a felirat, a többi sávon világos.
   ══════════════════════════════════════════════════════════════════════════ */

export function bgColor(pct) {
  if (pct >  5) return '#166534';
  if (pct >  3) return '#15803d';
  if (pct >  1) return '#16a34a';
  if (pct > -1) return '#1e293b';
  if (pct > -3) return '#991b1b';
  if (pct > -5) return '#b91c1c';
  return '#7f1d1d';
}

/* A hét sáv egy-egy jellemző értékkel (a kontrasztméréshez és a tesztekhez). */
export const BG_SAVOK = [
  { bg: '#7f1d1d', label: '< −5%', pct: -7 },
  { bg: '#b91c1c', label: '−5…−3%', pct: -4 },
  { bg: '#991b1b', label: '−3…−1%', pct: -2 },
  { bg: '#1e293b', label: '±1%', pct: 0.5 },
  { bg: '#16a34a', label: '+1…+3%', pct: 2 },
  { bg: '#15803d', label: '+3…+5%', pct: 4 },
  { bg: '#166534', label: '> +5%', pct: 7 },
];

const VILAGOS = { sym: '#ffffff', name: 'rgba(255,255,255,0.93)', price: 'rgba(255,255,255,0.96)', pct: '#ffffff' };
const SOTET = { sym: '#04170b', name: 'rgba(4,23,11,0.88)', price: 'rgba(4,23,11,0.92)', pct: '#04170b' };

/** A csempe feliratszínei a változás szerint: { sym, name, price, pct }. A semleges sávon (±1%) a
 *  változás színe jelzi az irányt (zöld / piros), a színes sávokon a háttér, ott a felirat egyszínű. */
export function tileInk(pct) {
  if (pct > 1 && pct <= 3) return SOTET;
  if (pct > -1 && pct <= 1) return { ...VILAGOS, pct: pct >= 0 ? '#4ade80' : '#ff8a8a' };
  return VILAGOS;
}
